export default {
  TYPE: {
    CREATED: { KEY: 0, LABEL: 'Criado', VALUE: 'criado' },
    APPROVED: { KEY: 1, LABEL: 'Aprovado', VALUE: 'aprovado' },
    DECLINED: { KEY: 2, LABEL: 'Rejeitado', VALUE: 'rejeitado' },
  },
};
